import React from 'react';

import PropTypes from 'prop-types';

import { URL_IMAGES_FLAG } from 'apps/promo/constants/UrlConstants';
import clsx from 'clsx';

import styles from './PromoFlagIcon.module.css';

export const PromoFlagIcon = (props) => {
    if (!props.name) return null;

    const sizeClass = props.size === 'adaptive-20-32' ? styles.adaptive_20_32 : styles.size24;

    return (
        <span
            className={clsx(styles.icon, sizeClass, {
                [styles.disabled]: props.isDisabled,
            })}
        >
            <img src={`${URL_IMAGES_FLAG}/${props.name}.png`} alt={props.name} loading="lazy" className={styles.img} />
        </span>
    );
};

PromoFlagIcon.propTypes = {
    name: PropTypes.string,
    size: PropTypes.oneOf(['24px', 'adaptive-20-32']),
    isDisabled: PropTypes.bool,
};
